import { providers } from '../../providers';
import { openrouter } from '../openrouter';
import type { VideoModelEntry } from '../types';

// 价格表: 美元/秒
const IMAGINE = { '480p': 0.05, '720p': 0.07 };
// 查找价格函数
const lookup = (table: Record<string, number>, quality?: string) =>
    table[quality ?? ''] ?? Math.max(...Object.values(table));

const COST_FACTOR = 1.5;

export const xaiModels: VideoModelEntry[] = [
    {
        id: 'grok-imagine-video',
        // 通用兜底默认（优先级 1）：无 international 标签的用户看不到 seedance 国际版（default: 2）时用它。
        default: true,
        chef: providers['xai'],
        providers: [
            {
                ...providers.xai,
                model: openrouter('grok-imagine-video'),
                getCost: ({ duration, quality }) => {
                    return duration * lookup(IMAGINE, quality) * COST_FACTOR;
                },
                getPassCount: ({ duration, quality }) => {
                    return duration * lookup(IMAGINE, quality) * COST_FACTOR * 100;
                },
            },
        ],
        configByMode: {
            'none': {
                aspectRatios: ['16:9', '9:16', '4:3', '3:4', '3:2', '2:3', '1:1'],
                durations: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p'],
                inlineMedia: {
                    image: { allow: false },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            'first': {
                aspectRatios: [],
                durations: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                qualities: ['480p', '720p'],
                inlineMedia: {
                    image: { allow: true, maxCount: 1, maxSize: '10MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            'ref': {
                aspectRatios: ['16:9', '9:16', '4:3', '3:4', '3:2', '2:3', '1:1'],
                durations: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                qualities: ['480p', '720p'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 7, maxSize: '10MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
        },
        precheckByMode: {
            none: ['prompt'],
            first: ['prompt', 'image'],
            ref: ['prompt', 'image'],
        },
        supportsEdit: false,
        supportsInput: ['t2v', 'first', 'reference'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
]